import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  ArInvoiceDto,
  ArInvoiceListDto,
  ArInvoiceFilterDto,
  CreateArInvoiceRequest,
  UpdateArInvoiceRequest,
} from '@/types/arInvoice.types';

export const arInvoiceApi = {
  /** GET /api/v1/ar-invoices — paginated list */
  getList: (filter?: ArInvoiceFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<ArInvoiceListDto>>>('/ar-invoices', { params: filter }),

  /** GET /api/v1/ar-invoices/{id} — full invoice with lines */
  getById: (id: string) =>
    apiClient.get<ApiResponse<ArInvoiceDto>>(`/ar-invoices/${id}`),

  /** POST /api/v1/ar-invoices — create new invoice (Draft) */
  create: (data: CreateArInvoiceRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/ar-invoices', data),

  /** PUT /api/v1/ar-invoices/{id} — update draft invoice */
  update: (id: string, data: UpdateArInvoiceRequest) =>
    apiClient.put<ApiResponse<object>>(`/ar-invoices/${id}`, data),

  /** POST /api/v1/ar-invoices/{id}/submit — submit for approval */
  submit: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/ar-invoices/${id}/submit`),

  /** POST /api/v1/ar-invoices/{id}/approve — approve the invoice */
  approve: (id: string, remarks?: string) =>
    apiClient.post<ApiResponse<object>>(`/ar-invoices/${id}/approve`, { remarks }),

  /** POST /api/v1/ar-invoices/{id}/reject — reject with reason */
  reject: (id: string, reason: string) =>
    apiClient.post<ApiResponse<object>>(`/ar-invoices/${id}/reject`, { reason }),

  /** POST /api/v1/ar-invoices/{id}/post — post to general ledger */
  post: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/ar-invoices/${id}/post`),

  /** POST /api/v1/ar-invoices/{id}/reverse — create credit note reversal */
  reverse: (id: string, reversalDate: string, reversalPostingDate: string, narration?: string) =>
    apiClient.post<ApiResponse<{ id: string }>>(`/ar-invoices/${id}/reverse`, {
      reversalDate,
      reversalPostingDate,
      narration,
    }),

  /** POST /api/v1/ar-invoices/{id}/cancel — cancel the invoice */
  cancel: (id: string, reason?: string) =>
    apiClient.post<ApiResponse<object>>(`/ar-invoices/${id}/cancel`, { reason }),

  /** DELETE /api/v1/ar-invoices/{id} — soft-delete (draft only) */
  delete: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/ar-invoices/${id}`),
};
